import { denormalize } from 'normalizr';
import { sortBy, prop, compose, toLower } from 'ramda';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';

import { types } from './actions';
import { processSchema } from './service';

const initialState = {
  entities: {},
  processIds: [],
  isCreating: false,
  isCreateModalOpen: false,
  isAccountDownloadModalOpen: false,
  isAccountDownloading: false,
  isAccountUploadModalOpen: false,
  isAccountUploading: false,
  isAccountValidateModalOpen: false,
  isAccountValidating: false,
};

const entitiesReducer = createEntitiesReducer(
  ['processes'],
  [types.INIT, types.CREATE_SUCCESS],
);

const reducer = (state, action) => {
  switch (action.type) {
    case types.INIT:
      return {
        ...state,
        processIds: action.payload.result,
      };
    case types.NEW_PROCESS_MODAL_OPEN:
      return {
        ...state,
        isCreateModalOpen: true,
      };
    case types.NEW_PROCESS_MODAL_CLOSE:
      return {
        ...state,
        isCreateModalOpen: false,
      };
    case types.CREATE_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case types.CREATE_SUCCESS:
      return {
        ...state,
        processIds: state.processIds.concat(action.payload.result),
        isCreating: false,
        isCreateModalOpen: false,
      };
    case types.CREATE_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case types.ACCOUNT_DOWNLOAD_MODAL_OPEN:
      return {
        ...state,
        isAccountDownloadModalOpen: true,
      };
    case types.ACCOUNT_DOWNLOAD_MODAL_CLOSE:
      return {
        ...state,
        isAccountDownloadModalOpen: false,
      };
    case types.ACCOUNT_DOWNLOAD_REQUEST:
      return {
        ...state,
        isAccountDownloading: true,
      };
    case types.ACCOUNT_DOWNLOAD_ERROR:
    case types.ACCOUNT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        isAccountDownloading: false,
      };
    case types.ACCOUNT_UPLOAD_MODAL_OPEN:
      return {
        ...state,
        isAccountUploadModalOpen: true,
      };
    case types.ACCOUNT_UPLOAD_MODAL_CLOSE:
      return {
        ...state,
        isAccountUploadModalOpen: false,
      };
    case types.ACCOUNT_UPLOAD_REQUEST:
      return {
        ...state,
        isAccountUploading: true,
      };
    case types.ACCOUNT_UPLOAD_ERROR:
    case types.ACCOUNT_UPLOAD_SUCCESS:
      return {
        ...state,
        isAccountUploading: false,
      };
    case types.ACCOUNT_VALIDATE_MODAL_OPEN:
      return {
        ...state,
        isAccountValidateModalOpen: true,
      };
    case types.ACCOUNT_VALIDATE_MODAL_CLOSE:
      return {
        ...state,
        isAccountValidateModalOpen: false,
      };
    case types.ACCOUNT_VALIDATE_REQUEST:
      return {
        ...state,
        isAccountValidating: true,
      };
    case types.ACCOUNT_VALIDATE_ERROR:
    case types.ACCOUNT_VALIDATE_SUCCESS:
      return {
        ...state,
        isAccountValidating: false,
      };
    default:
      return state;
  }
};

export const getScope = (state) => state.modules.processes.listPage;

export const getIsCreating = (state) => getScope(state).isCreating;

export const getIsCreateModalOpen = (state) =>
  getScope(state).isCreateModalOpen;

export const getProcessIds = (state) => getScope(state).processIds;

export const getProcessById = (state, processId) =>
  denormalize(processId, processSchema, getScope(state).entities);

export const getProcesses = (state) => {
  const sortByNameCaseInsensitive = sortBy(compose(toLower, prop('name')));
  return sortByNameCaseInsensitive(
    getProcessIds(state).map((id) => getProcessById(state, id)),
  );
};

export const getIsAccountDownloadModalOpen = (state) =>
  getScope(state).isAccountDownloadModalOpen;
export const getIsAccountDownloading = (state) =>
  getScope(state).isAccountDownloading;
export const getIsAccountUploadModalOpen = (state) =>
  getScope(state).isAccountUploadModalOpen;
export const getIsAccountUploading = (state) =>
  getScope(state).isAccountUploading;
export const getIsAccountValidateModalOpen = (state) =>
  getScope(state).isAccountValidateModalOpen;
export const getIsAccountValidating = (state) =>
  getScope(state).isAccountValidating;

export default reduceReducers(entitiesReducer, reducer, initialState);
